import { IRegistrableInstance } from './Registrable'
import { onDroppableBubbleDrop, onDroppableBubbleDragleave, onDroppableBubbleDragover } from './handlers'

class DroppableBubble extends IRegistrableInstance {
  constructor (el, component, direction) {
    super()
    this.el = el

    this.onDragover = onDroppableBubbleDragover.bind(this, component)
    this.onDragleave = onDroppableBubbleDragleave.bind(this, component)
    this.onDrop = onDroppableBubbleDrop.bind(this, component, direction)
  }

  registered () {
    this.el.addEventListener('dragover', this.onDragover)
    this.el.addEventListener('dragleave', this.onDragleave)
    this.el.addEventListener('drop', this.onDrop)
  }

  unregistered () {
    this.el.removeEventListener('dragover', this.onDragover)
    this.el.removeEventListener('dragleave', this.onDragleave)
    this.el.removeEventListener('drop', this.onDrop)
  }
}

export default DroppableBubble
